import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Logo";
import { Home } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-[#05050A] grid-bg flex flex-col items-center justify-center px-5 text-center relative overflow-hidden">
      <div className="aura w-[400px] h-[400px] bg-violet-700/20 top-10 left-1/4" />
      <div className="relative">
        <Logo size="text-4xl" />
        <p className="mt-8 font-display font-bold text-6xl text-gradient">404</p>
        <p className="mt-4 text-zinc-400 max-w-md">{t("notFound.text")}</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 bg-brand-gradient text-white font-semibold px-6 py-3 rounded-full hover:opacity-90 transition-opacity duration-300">
          <Home className="w-4 h-4" /> {t("notFound.home")}
        </Link>
      </div>
    </div>
  );
}
